import {RolesEnum} from 'permissions/enums';
import {intersection} from 'utils';

export function hasRequiredPermissions(userRoles: RolesEnum[], requiredRoles: RolesEnum[]): boolean {
  return intersection(userRoles, requiredRoles as RolesEnum[]).length > 0;
}
